import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type { AuthenticatedSyfRouteModel } from 'tio-employee/routes/authenticated/syf';

export default class AuthenticatedSyfIndexRoute extends Route {
  @service declare router: RouterService;

  model() {
    return this.modelFor('authenticated.syf');
  }

  afterModel(model: AuthenticatedSyfRouteModel | null) {
    if (model && model.matchParticipant.isEnrolled) {
      this.router.transitionTo('authenticated.syf.dashboard');
    } else {
      this.router.transitionTo('authenticated.syf.enrollment');
    }
  }
}
